module.exports = __webpack_public_path__ + "42796ac1742601998cf47bc5c7bf03a8.mp4";